import './SearchResultItem.scss'

import ListItem from 'components/App/components/ListItem'
import SvgPdsMarkerIcon from 'components/Map/components/SvgPdsMarkerIcon'
import { TripAdvisorRating } from 'components/TripAdvisorRating'
import { PageType, useNavigation } from 'lib/hooks'
import React from 'react'

import SearchResultItemDetails from '../SearchResultItemDetails'

interface SearchResultItemProps {
  id: string
  iconName?: string
  categoryId?: string
  link: string
  title: string
  highlightedSubtitle?: string
  subtitle?: string
  thumbnail?: string
  averageRating?: number
  reviewCount?: number
  isHighlighted?: boolean
  onClick: (id: string) => void
  onMouseEnter: (id: string) => void
  onMouseLeave: (id: string) => void
}

const Thumbnail = ({ thumbnail }: { thumbnail: string }): JSX.Element => (
  <img src={thumbnail} className="SearchResultItem__thumbnail" />
)

const SearchIcon = ({
  categoryId,
}: {
  categoryId: string | undefined
  iconName: string | undefined
}): JSX.Element => (
  <div className="SearchResultItem__icon-container">
    <SvgPdsMarkerIcon
      className="SearchResultItem__icon"
      categoryId={categoryId}
      innerColor="white"
    />
  </div>
)

export default function SearchResultItem({
  id,
  iconName,
  categoryId,
  link,
  title,
  highlightedSubtitle,
  subtitle,
  thumbnail,
  averageRating,
  reviewCount,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: SearchResultItemProps): JSX.Element {
  const { goTo } = useNavigation()
  const handleMouseClick = (): void => {
    const pageType = link.includes('/discover/') ? PageType.DISCOVERY : PageType.PDC

    onClick(id)
    goTo({ type: pageType, url: link })
  }

  const handleMouseEnter = (): void => {
    onMouseEnter(id)
  }

  const handleMouseLeave = (): void => {
    onMouseLeave(id)
  }

  // an icon container is always shown (even when there's no icon) to have consistent offset
  return (
    <ListItem
      className="SearchResultItem"
      onClick={handleMouseClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="SearchResultItem__link">
        {thumbnail !== undefined ? (
          <Thumbnail thumbnail={thumbnail} />
        ) : (
          <SearchIcon iconName={iconName} categoryId={categoryId} />
        )}

        <SearchResultItemDetails
          title={title}
          subtitle={subtitle}
          highlightedSubtitle={highlightedSubtitle}
        >
          {averageRating !== undefined && reviewCount !== undefined && (
            <TripAdvisorRating value={averageRating} reviewCount={reviewCount} />
          )}
        </SearchResultItemDetails>
      </div>
    </ListItem>
  )
}
